import { MessageCircle } from "lucide-react";
import { mockData } from "../mock";

export const WhatsAppButton = () => {
  const handleClick = () => {
    const message = encodeURIComponent(
      "Olá! Gostaria de solicitar um orçamento."
    );
    window.open(
      `https://wa.me/${mockData.company.whatsapp}?text=${message}`,
      "_blank"
    );
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition-all hover:scale-110 z-50 animate-bounce"
      aria-label="Contato WhatsApp"
    >
      <MessageCircle size={28} />
    </button>
  );
};
